export default __webpack_public_path__ + "static/media/main.b6f4f1f4.jpg";